import {
  ComplianceCheck,
  ComplianceCheckStatus,
  ComplianceCheckType,
} from '__generated__/graphql';

// Status of the check of the given type.
// "Latest" = most recent result; each evaluation overwrites the prior one, so there's one record per type per line.
export const getLatestComplianceCheckStatus = (
  complianceChecks: ComplianceCheck[] | null | undefined,
  type: ComplianceCheckType,
): ComplianceCheckStatus | undefined =>
  complianceChecks?.find((check) => check.type === type)?.status ?? undefined;
